import script from "./accordionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./accordionSection.vue?vue&type=script&setup=true&lang=js"

import "./accordionSection.vue?vue&type=style&index=0&id=217b75d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-217b75d6"]])

export default __exports__